import { render, staticRenderFns } from "./Academics.vue?vue&type=template&id=ae71b5f2"
import script from "./Academics.vue?vue&type=script&lang=js"
export * from "./Academics.vue?vue&type=script&lang=js"
import style0 from "./Academics.vue?vue&type=style&index=0&id=ae71b5f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports